export const colors = {
  coral: '#EBA09B',
  coralLight: '#FAEDEB',
  coralMid: '#F5C9C4',
  terracotta: '#E8927C',
  deepCoral: '#D4796A',
  peach: '#F5B9A5',
  blushPink: '#FABEC0',
  warmYellow: '#F5D7AA',
  sage: '#B5C9A8',
  deepSage: '#6B9A7A',
  deepTeal: '#3D7478',
  dark: '#272726',
  charcoal: '#272726',
  warmGray: '#666666',
  midGray: '#888888',
  lightGray: '#F5F5F5',
  offWhite: '#FAF8F6',
  border: '#E8E8E8',
  white: '#FFFFFF',
};

export const gradients = {
  primary: 'linear-gradient(90deg, #FABEC0 0%, #F5D7AA 50%, #B5C9A8 100%)',
  primarySoft:
    'linear-gradient(135deg, rgba(250,190,192,0.4) 0%, rgba(245,215,170,0.32) 50%, rgba(181,201,168,0.28) 100%)',
  primaryWash:
    'linear-gradient(135deg, rgba(250,190,192,0.22) 0%, rgba(245,215,170,0.18) 50%, rgba(181,201,168,0.15) 100%)',
  coralPeach: 'linear-gradient(135deg, #EBA09B 0%, #F5B9A5 100%)',
};

export const fonts = {
  serif: '"Source Serif Pro", Georgia, serif',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export const sectionStyle = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '96px 48px',
};

export const innerStyle = {
  maxWidth: '1100px',
  margin: '0 auto',
};

export const sectionLabelStyle = {
  fontFamily: fonts.sans,
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '2.4px',
  textTransform: 'uppercase',
  color: colors.deepCoral,
  margin: '0 0 18px',
};

export const ctaPrimaryStyle = {
  backgroundColor: colors.terracotta,
  color: colors.white,
  fontFamily: fonts.sans,
  fontSize: '15px',
  fontWeight: 600,
  padding: '16px 32px',
  borderRadius: '8px',
  textDecoration: 'none',
  display: 'inline-block',
  border: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease, transform 0.15s ease',
};

export const ctaSecondaryStyle = {
  backgroundColor: 'transparent',
  color: 'rgba(255,255,255,0.55)',
  fontFamily: fonts.sans,
  fontSize: '15px',
  fontWeight: 400,
  padding: '16px 32px',
  borderRadius: '8px',
  textDecoration: 'none',
  border: '1px solid rgba(255,255,255,0.15)',
  display: 'inline-block',
  transition: 'border-color 0.2s ease, color 0.2s ease',
};

export const revealStyle = (isVisible) => ({
  opacity: isVisible ? 1 : 0,
  transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
  transition: 'opacity 0.6s ease, transform 0.6s ease',
});
